import BaseMediaLinkService from "./media-link-service";

class DevelopmentMediaLinkService extends BaseMediaLinkService {
  protected vertical: "development" | "chapter" = "development";
}

export default DevelopmentMediaLinkService;
